new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {

    var bannerHomeFull = $('.home__banner');
    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    let rotationNames = document.querySelectorAll('.rotation-banner-select .rotation-banner-select-item');
    let initVitrine = document.querySelectorAll('.rotation-banner-list .rotation-banner-list-content');
    let allBanners = initVitrine;

    if (rotationNames.length && initVitrine.length) {
        initVitrine[0].classList.add('active');
        rotationNames[0].classList.add('active');
        function activeTab(index) {
            initVitrine.forEach((content) => {
                content.classList.remove('active');
            });
            rotationNames.forEach((content) => {
                content.classList.remove('active');
            });
            initVitrine[index].classList.add('active');
            rotationNames[index].classList.add('active');

            // Atualizar classe no contêiner .count
            $('.count-banner').attr('class', function (i, c) {
                return c.replace(/(^|\s)count-banner-\S+/g, '');
            }).addClass(`count-banner-${index + 1}`);

            // Adiciona refresh no carrossel correspondente ao index
            if (allBanners && allBanners[index]) {
                const $carousel = $(allBanners[index]);
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('refresh');
                }
            }
        }

        rotationNames.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', (e) => {
                e.preventDefault();
                activeTab(index);
            }, { passive: true });
        });

        // Initial update for the first active tab
        activeTab(0);
    }

    $('#carrousel-product-list').slick({
        arrows: true,
        swipeToSlide: true,
        touchThreshold: 100,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#carrousel-product-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('#carrousel-product-list2').slick({
        arrows: true,
        swipeToSlide: true,
        touchThreshold: 100,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#carrousel-product-list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('.info-banner-carousel').slick({
        arrows: false,
        dots: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                }
            }
        ]
    });

    $('.info-banners-wrapper').slick({
         arrows: false,
        dots: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    });
    
});